import React from 'react';
import html2canvas from 'html2canvas';
import moment from 'moment';
import jsPDF from 'jspdf';
import { Box } from '@mui/material';
import { Watermark } from 'antd';
import { useLocation } from 'react-router-dom';
import FlightDetailRowTBO from './Ticket/FlightDetailRowTBO';
const Ticket = () => {
	const location = useLocation();
	console.log('location', location);
	const handleDownload = () => {
		const capture = document.querySelector('.download');
		html2canvas(capture).then((canvas) => {
			const imgData = canvas.toDataURL('img/png');
			const doc = new jsPDF('p', 'mm', [500, 500]);
			const componentWidth = doc.internal.pageSize.getWidth();
			const componentHeight = doc.internal.pageSize.getHeight();
			doc.addImage(imgData, 'PNG', 0, 0, componentWidth, componentHeight);
			doc.save('ticket.pdf');
		});
	};
	console.log('selectedFlight', JSON.parse(location.state.selectedFlight));
	return (
		<Watermark content='Musafir Bazar'>
			<div
				className='download'
				style={{ padding: 50, border: '1px solid #333' }}>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: 8,
						border: '1px solid #333',
						alignItems: 'center',
					}}>
					<Box style={{ textAlign: 'center' }}>
						<img
							src={'https://nitish.musafirbazar.com/static/logo/HOLIDAYS.jpg'}
							style={{
								maxHeight: 50,
								maxWidth: 150,
							}}></img>
					</Box>
					<Box></Box>
					<Box>
						<Box>
							<span>Name: </span>
						</Box>{' '}
						<Box mt={0.5}>
							<span>Email: </span>
						</Box>{' '}
						<Box mt={0.5}>
							<span>Phone: +91 </span>
						</Box>
						<Box mt={0.5}>
							<span>
								{' '}
								Address: 141st Floor,New Tech Grand, Bank More, Dhanbad-826001
							</span>
						</Box>
					</Box>
					<Box></Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: 8,
						border: '1px solid #333',
						alignItems: 'center',
					}}>
					<Box>
						<Box>
							<span>Booking Time: {location.state.dob}</span>
						</Box>{' '}
						<Box mt={0.5}>
							<span>Booking ID: {location.state.orderId}</span>
						</Box>{' '}
						<Box mt={0.5}>
							<span>Booking Status: Booked</span>
						</Box>
					</Box>

					<Box></Box>
					<Box style={{ textAlign: 'center' }}>
						<span style={{ fontSize: 24, fontWeight: 'bold' }}>
							{location.state.bookingRefrence}
						</span>
						<br></br>
						<span style={{ fontSize: 20, textAlign: 'center' }}>PNR</span>
					</Box>
					<Box></Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						background: '#000',
						padding: 8,
					}}>
					<Box>
						<span style={{ color: 'white' }}>Flight Details</span>
					</Box>
					<Box>
						<span style={{ color: 'white' }}>
							*Please verify flight timings & terminal info with the airlines
						</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						background: '#BCBEC0',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span>Flight</span>
					</Box>
					<Box>
						<span>class</span>
					</Box>
					<Box>
						<span>Stop</span>
					</Box>
					<Box>
						<span>Departing</span>
					</Box>
					<Box>
						<span>Arriving</span>
					</Box>
					<Box>
						<span>Duration</span>
					</Box>
					<Box>
						<span>Baggage</span>
					</Box>
				</Box>
				{location.state.journeyType.toLowerCase() === 'oneway' ? (
					<>
						{location.state.supplier === 'TBO' &&
							location?.state?.selectedFlight &&
							JSON.parse(location?.state?.selectedFlight)?.Segments[0]?.map(
								(item, index) => {
									return <FlightDetailRowTBO item={item} />;
								}
							)}
						{location.state.supplier === 'ETR' &&
							location?.state?.selectedFlight &&
							JSON.parse(location?.state?.selectedFlight)?.Segments?.map(
								(item, index) => {
									return (
										<tr>
											<td
												width='20%'
												style={{
													padding: 2,
													fontSize: 12,
													paddingLeft: 20,
												}}>
												<p>
													<strong style={{ color: '#000' }}>
														{item.Airline_Code}-{item.Flight_Number}
													</strong>
												</p>
												<p>
													<span style={{ fontWeight: 400 }}>
														{item.Airline_Name}
													</span>
												</p>
											</td>
											<td
												width='10%'
												style={{
													padding: 2,
													fontSize: 12,
												}}>
												<p>
													<span style={{ fontWeight: 400 }}>
														{
															JSON.parse(location?.state?.selectedFlight)?.Fares
																.FareDetails[0]?.FareClasses[0]?.Class_Code
														}
													</span>
												</p>
											</td>
											<td width='10%'>
												<p style={{ fontSize: 12 }}>
													<span style={{ fontWeight: 400 }}>Non Stop</span>
												</p>
											</td>
											<td width='20%'>
												<p style={{ fontSize: 12 }}>
													<strong color='#000'>
														{`${moment(item.Departure_DateTime).format(
															'DD-MM-YYYY'
														)} ${item.Departure_DateTime.split(' ')[1]}`}
													</strong>
												</p>
												<p style={{ fontSize: 12 }}>
													<span style={{ fontWeight: 400 }}>{item.Origin}</span>
												</p>
											</td>
											<td width='20%'>
												<p style={{ fontSize: 12 }}>
													<strong color='#000'>
														{`${moment(item.Arrival_DateTime).format(
															'DD-MM-YYYY'
														)} ${item.Arrival_DateTime.split(' ')[1]} `}
													</strong>
												</p>
												<p style={{ fontSize: 12 }}>
													<span style={{ fontWeight: 400 }}>
														{item.Destination}
													</span>
												</p>
											</td>
											<td width='10%'>
												<p style={{ fontSize: 12 }}>
													<strong color='#000'>{`${item.Duration} min`}</strong>
												</p>
											</td>
											<td width='10%'>
												<p style={{ fontSize: 12 }}>
													<strong color='#000'>
														{`${
															JSON.parse(location?.state?.selectedFlight)?.Fares
																?.FareDetails[0]?.Free_Baggage?.Check_In_Baggage
														} || ${
															JSON.parse(location?.state?.selectedFlight)?.Fares
																?.FareDetails[0]?.Free_Baggage?.Hand_Baggage
														}`}
													</strong>
												</p>
											</td>
										</tr>
									);
								}
							)}
					</>
				) : (
					<>
						{location.state.supplier === 'TBO' &&
							location?.state?.selectedFlight &&
							location?.state?.selectedFlight.length < 0 &&
							JSON.parse(location?.state?.selectedFlight)?.Segments[0]?.map(
								(item, index) => {
									return <FlightDetailRowTBO item={item} />;
								}
							)}
						{location.state.supplier === 'TBO' &&
							location?.state?.selectedFlight &&
							location?.state?.selectedFlight.length < 0 &&
							JSON.parse(location?.state?.selectedFlight)?.Segments[1]?.map(
								(item, index) => {
									return <FlightDetailRowTBO item={item} />;
								}
							)}
						{location.state.supplier === 'TBO' &&
							location?.state?.selectedFlight &&
							location?.state?.selectedFlight.length > 0 &&
							JSON.parse(location?.state?.selectedFlight)[0]?.Segments[0]?.map(
								(item, index) => {
									return <FlightDetailRowTBO item={item} />;
								}
							)}
						{location.state.supplier === 'TBO' &&
							location?.state?.selectedFlight &&
							location?.state?.selectedFlight.length > 0 &&
							JSON.parse(location?.state?.selectedFlight)[1]?.Segments[0]?.map(
								(item, index) => {
									return <FlightDetailRowTBO item={item} />;
								}
							)}
					</>
				)}
				<Box
					style={{
						display: 'flex',
						background: '#000',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span style={{ color: 'white' }}>Passenger Details</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						background: '#BCBEC0',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span>Sr.</span>
					</Box>
					<Box>
						<span>Name</span>
					</Box>
					<Box>
						<span>Type</span>
					</Box>
					<Box>
						<span>PNR & Ticket No.</span>
					</Box>
				</Box>
				{JSON.parse(location.state.selectedPax) &&
					JSON.parse(location?.state?.selectedPax)?.map((item, index) => {
						return (
							<Box
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									padding: 8,
									border: '1px solid #333',
								}}>
								<Box>
									<span>{index + 1}</span>
								</Box>
								<Box>
									<span>{`${item.title} ${item.firstname} ${item.lastname}`}</span>
								</Box>
								<Box>
									<span>
										{item.PaxType === 1
											? 'Adult'
											: item.PaxType === 2
											? 'Child'
											: item.PaxType === 3
											? 'Infant'
											: ''}
									</span>
								</Box>
								<Box>
									<span>{location.state.bookingRefrence}</span>
								</Box>
							</Box>
						);
					})}
				<Box
					style={{
						display: 'flex',
						background: '#000',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span style={{ color: 'white' }}>Contact Details</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span>Phone: +91 {location.state.userPhone}</span>
					</Box>
					<Box>
						<span>Email: {location.state.userEmail}</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						background: '#000',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span style={{ color: 'white' }}>Fare Details</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span>Total Price</span>
					</Box>
					<Box>
						<span>INR {location.state.ticketCost}</span>
					</Box>
				</Box>
				<Box
					style={{
						display: 'flex',
						background: '#000',
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span style={{ color: 'white' }}>Important Information</span>
					</Box>
				</Box>
				<Box
					style={{
						padding: 8,
						border: '1px solid #333',
					}}>
					<Box>
						<span>
							1 - You must web check-in on the airline website and obtain a
							boarding pass.
						</span>
					</Box>
					<Box>
						<span>
							2 - You must download & register on the Aarogya Setu App and carry
							a Valid ID
						</span>
					</Box>
					<Box>
						<span>
							3 - It is mandatory to wear a musk and carry other protective
							gear.
						</span>
					</Box>
					<Box>
						<span>
							4 - Reach the terminal at least 2 hours prior to the departure for
							domestic flight and 4 hors prior to the departure of international
							flight .
						</span>
					</Box>
					<Box>
						<span>
							5 - For departure terminal please check with the airline
						</span>
					</Box>
					<Box>
						<span>
							6 - Date & Time is calculated based on the local time of the
							city/destination.
						</span>
					</Box>
					<Box>
						<span>
							7 - Use the Airline PNR for all Correspondence directly with the
							Airline.
						</span>
					</Box>
					<Box>
						<span>
							8 - For rescheduling/cancellation within 4hours of the departure
							time contact the airline directly.
						</span>
					</Box>
					<Box>
						<span>
							9 - Your ability to travel is at the sole discretion of the
							airport authorities and we shall not be held responsible.
						</span>
					</Box>
				</Box>
				<button
					onClick={handleDownload}
					style={{
						backgroundColor: 'darkblue',
						border: '2px solid #cb134e',
						color: 'white',
						padding: '6px 42px',
						marginTop: 10,
					}}>
					Download
				</button>
				<button
					onClick={handleDownload}
					style={{
						backgroundColor: 'darkblue',
						border: '2px solid #cb134e',
						color: 'white',
						padding: '6px 42px',
						marginTop: 10,
						marginLeft: 10,
					}}>
					Edit Price
				</button>
			</div>
		</Watermark>
	);
};

export default Ticket;
